import React from 'react';

const data = [
  {
    height: 43,
    avg: 147,
    yellow: '74 - 118',
    red: '< 74',
  },
  {
    height: 44,
    avg: 160,
    yellow: '80 - 128',
    red: '< 80',
  },
  {
    height: 45,
    avg: 173,
    yellow: '87 - 139',
    red: '< 87',
  },
  {
    height: 46,
    avg: 187,
    yellow: '94 - 150',
    red: '< 94',
  },
  {
    height: 47,
    avg: 200,
    yellow: '100 - 160',
    red: '< 100',
  },
  {
    height: 48,
    avg: 214,
    yellow: '107 - 171',
    red: '< 107',
  },
  {
    height: 49,
    avg: 227,
    yellow: '114 - 182',
    red: '< 114',
  },
  {
    height: 50,
    avg: 240,
    yellow: '120 - 192',
    red: '< 120',
  },
  {
    height: 51,
    avg: 254,
    yellow: '127 - 203',
    red: '< 127',
  },
  {
    height: 52,
    avg: 267,
    yellow: '134 - 214',
    red: '< 134',
  },
  {
    height: 53,
    avg: 280,
    yellow: '140 - 224',
    red: '< 140',
  },
  {
    height: 54,
    avg: 293,
    yellow: '147 - 234',
    red: '< 147',
  },
  {
    height: 55,
    avg: 307,
    yellow: '154 - 246',
    red: '< 154',
  },
  {
    height: 56,
    avg: 320,
    yellow: '160 - 256',
    red: '< 160',
  },
  {
    height: 57,
    avg: 334,
    yellow: '167 - 267',
    red: '< 167',
  },
  {
    height: 58,
    avg: 347,
    yellow: '174 - 278',
    red: '< 174',
  },
  {
    height: 59,
    avg: 360,
    yellow: '180 - 288',
    red: '< 180',
  },
  {
    height: 60,
    avg: 373,
    yellow: '187 - 298',
    red: '< 187',
  },
  {
    height: 61,
    avg: 387,
    yellow: '194 - 310',
    red: '< 194',
  },
  {
    height: 62,
    avg: 400,
    yellow: '200 - 320',
    red: '< 200',
  },
  {
    height: 63,
    avg: 413,
    yellow: '207 - 330',
    red: '< 207',
  },
  {
    height: 64,
    avg: 427,
    yellow: '214 - 342',
    red: '< 214',
  },
  {
    height: 65,
    avg: 440,
    yellow: '220 - 352',
    red: '< 220',
  },
  {
    height: 66,
    avg: 454,
    yellow: '227 - 363',
    red: '< 227',
  },
];

const PeakFlowGuide = () => {
  return (
    <div className="peak-flow-guide">
      <a data-toggle="modal" data-target="#peakFlowGuide" style={{cursor: "pointer"}}>
        For your reference, click here to view average peak flows by height.
      </a>
      <div className="modal fade" id="peakFlowGuide">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 style={{margin: 0}}>
                Average peak flow rate for healthy children and teenagers
              </h4>
            </div>
            <div className="modal-body">
              <p>
                All tables are average based on tests with a large number of people, and should be used as a guide only.
                Peak flows vary with the type of meter used.
              </p>
              <table className="table table-striped table-bordered" style={{ overflowX: 'scroll', height: '200px' }}>
                <thead style={{ backgroundColor: '#E8E8E8'}}>
                  <tr>
                    <th className="text-center">Height in Inches</th>
                    <th className="text-center"> Average peak flow</th>
                    <th className="text-center">Yellow Zone 50-80% of average peak flow</th>
                    <th className="text-center">Red Zone less than 50% of average peak flow</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item) => {
                    return (
                      <tr key={item.height}>
                        <td className="text-center">{item.height}</td>
                        <td className="text-center">{item.avg}</td>
                        <td className="text-center">{item.yellow}</td>
                        <td className="text-center">{item.red}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <p style={{fontStyle: "italic"}}>
                Source: Polgar, G. and Promadht, V.: Pulmonary Function Testing in Children: Techniques and Standards,
                Philadelphia, WB Saunders Company, 1979.
              </p>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-default" data-dismiss="modal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PeakFlowGuide;
